module.exports = __webpack_public_path__ + "img/madera3.f5d3f6fb.jpg";